<template>
  <div>
    <div>
      <!-- <navComponent></navComponent> -->
      <div class="container" v-if="!isMobile && !isSafari">
        <div
          :class="arePermissionDenied ? 'permission-not-granted' : 'default'"
        >
          <img
            src="../assets/permissions-blocked-2.png"
            width="550"
            height="200"
          />
          <h4>Your media permissions are blocked</h4>
          <h6>
            Meetbeans need access to your camera and audio. To use Meetbeans,
          </h6>
          <ol>
            <li>
              Click the Camera blocked icon,
              <img src="../assets/blocked-icon.png" /> in your browser's address
              bar
            </li>
            <li>Allow access and then refresh the page</li>
          </ol>
        </div>
        <div class="mt-5">
          <div
            class="row"
            :style="[
              { position: 'relative' },
              { opacity: arePermissionDenied ? '0.1' : '1' },
            ]"
          >
            <div class="col-12 col-sm-6">
              <div
                id="video-preview"
                class=""
                style="width:100%;height: 416px; background: #1B1B1B;justify-content: center;align-items: center"
              >
                <h5 v-show="!isCameraPermissionGranted" class="position-center">
                  The Camera is off
                </h5>
              </div>
              <div
                style="z-index:100; position:absolute; top: 2%;"
                v-show="isCameraPermissionGranted"
              >
                <div class="d-flex" style="align-items: center;">
                  <div class="audio-indicator" id="left-audio-indicator"></div>
                  <div class="audio-indicator" id="right-audio-indicator"></div>
                  <div class="audio-indicator" id="main-audio-indicator"></div>
                </div>
              </div>
              <!--					    <div v-show="isCameraPermissionGranted" class="ag-btn-group" style="justify-content: center;align-items: center">-->
              <!--		          <span-->
              <!--			          class="ag-btn videoControlBtn"-->
              <!--			          @click="handleCamera"-->
              <!--			          title="Enable/Disable Video"-->
              <!--		          >-->
              <!--                <i class="fas fa-video-slash"></i>-->
              <!--                <i class="fas fa-video"></i>-->
              <!--              </span>-->
              <!--						    <span-->
              <!--							    class="ag-btn audioControlBtn"-->
              <!--							    @click="handleMic"-->
              <!--							    title="Enable/Disable Audio"-->
              <!--						    >-->
              <!--                <i class="fas fa-microphone-slash"></i>-->
              <!--                <i class="fas fa-microphone"></i>-->
              <!--              </span>-->
              <!--					    </div>-->
            </div>
            <div class="col-12 col-sm-6 mt-5">
              <h3
                v-show="
                  arePermissionGranted &&
                    !isAudioPermissionGranted &&
                    !isCameraPermissionGranted
                "
              >
                Please click Allow to grant permissions
              </h3>
              <h3
                v-show="
                  arePermissionGranted &&
                    isAudioPermissionGranted &&
                    isCameraPermissionGranted
                "
              >
                Ready to join ?
              </h3>
              <h3 v-show="!arePermissionGranted">
                Please check your media permissions
              </h3>
              <h6>There is no fun in a meet without audio and camera</h6>
              <div
                class="setting"
                v-show="
                  arePermissionGranted &&
                    isAudioPermissionGranted &&
                    isCameraPermissionGranted
                "
              >
                <div class="form-group">
                  <p>Please set up & test your audio and video</p>
                  <label>Select Camera</label>
                  <select
                    class="form-control"
                    v-model="selectedCamera"
                    required
                    id="setting-camera"
                  >
                    <option
                      v-for="(item, index) in videoDeviceContainer"
                      :value="item"
                      :key="index"
                      >{{ item }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label>Select Mic</label>
                  <select
                    class="form-control"
                    v-model="selectedMic"
                    required
                    id="setting-mic"
                  >
                    <option
                      v-for="(item, index) in audioDeviceContainer"
                      :value="item"
                      :key="index"
                      :selected="selectedMic === item"
                      >{{ item }}</option
                    >
                  </select>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between">
                <div id="setting-info">
                  <span class="text-primary" @click="handleFixIssue">
                    <i class="fas fa-info-circle"></i>
                    <a href="#" target="_blank" class="ml-1"
                      ><b>Still facing issue?</b></a
                    >
                  </span>
                  <div
                    class="tooltip-text"
                    style="background-color: #101010; border: 1px solid; border-radius: 10px; color: #fff; font-size: 12px;"
                  >
                    <b>Still facing issue ?</b>
                    <ul style="text-align: left;">
                      <li>
                        Please check your browser pop-up blocker, it might be
                        blocking the camera and mic access.
                      </li>
                      <li>
                        Meetbeans works best in Google Chrome Browser Version 58
                        and above. Please check your browser here
                        <a href="https://www.whatismybrowser.com/"
                          >https://www.whatismybrowser.com/</a
                        >
                      </li>
                      <li>
                        If you experience video and audio lag, please check your
                        internet connection. You can test the speed
                        <a
                          href="https://www.whatismybrowser.com/detect/speed-test?utm_source=whatismybrowsercom&utm_medium=internal&utm_campaign=homepage&utm_content=detect-result"
                          >here
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <button
                  class="btn btn-primary float-right"
                  v-show="
                    arePermissionGranted &&
                      isAudioPermissionGranted &&
                      isCameraPermissionGranted
                  "
                  @click="submit"
                >
                  Save Preferences
                </button>
                <!-- <button
									class="btn btn-primary float-right"
									v-show="!preferencesSaved && arePermissionGranted"
								>
									Join Now
								</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AgoraRTC from "agora-rtc-sdk";
// import navComponent from "@/components/nav.vue";
// import AgoraVideoCall from "./AgoraVideoCall";
var DetectRTC = require("detectrtc");

export default {
  name: 'quickSetting',
  components: {
    // navComponent,
    // AgoraVideoCall,
  },
  data() {
    return {
      isMobile: false,
      isSafari: false,
      audioDeviceContainer: [],
      videoDeviceContainer: [],
      audioDeviceConfiguration: [],
      videoDeviceConfiguration: [],
      selectedCamera: "",
      selectedMic: "",
      uid: 1000000001,
      arePermissionGranted: true,
      isCameraPermissionGranted: false,
      isAudioPermissionGranted: false,
      previewStream: {},
      preferencesSaved: false,
      arePermissionDenied: false,
    };
  },
  mounted() {
    const $ = this;
    DetectRTC.load(function() {
      if (DetectRTC.isMobileDevice) {
        $.isMobile = true;
        this.$store.state.showPermission = false;
      }
      if (DetectRTC.browser.isSafari) {
        $.isSafari = true;
        this.$store.state.showPermission = false;
      }
      if ($.isMobile === false && $.isSafari === false) {
        // console.log($.isSafari , ' ', $.isMobile)
        $.showSetting();
      }
    });
    // window.addEventListener("orientationchange", this.handleOrientationChange);
  },
  methods: {
    handleFixIssue(e) {
      e.preventDefault();
      document.getElementById("setting-close").click();
      let routeData = this.$router.resolve({
        name: "fix-issues",
        query: { data: "setting" },
      });
      window.open(routeData.href, "_blank");
    },
    handleOrientationChange() {
      const orientation = window.screen.orientation.type;
      if (orientation === "portrait-primary") {
        // portrait mode
      } else if (orientation === "landscape-primary") {
        // landscape mode
      }
    },
    showSetting: function() {
      let $ = this;
      $.allowPermissionState = false;
      $.handleDeviceSwitch();
      AgoraRTC.getDevices(function(devices) {
        var audioDevices = devices.filter(function(device) {
          return device.kind === "audioinput";
        });
        var videoDevices = devices.filter(function(device) {
          return device.kind === "videoinput";
        });

        var selectedMicrophoneId = audioDevices[0].deviceId;
        console.log("MicrophoneId: ", selectedMicrophoneId);

        var selectedCameraId = videoDevices[0].deviceId;
        console.log("CameraId: ", selectedCameraId);
        $.previewStream = AgoraRTC.createStream({
          streamID: $.uid,
          audio: true,
          microphoneId: selectedMicrophoneId,
          video: true,
          cameraId: selectedCameraId,
          screen: false,
        });

        $.previewStream.init(
          function() {
            $.arePermissionGranted = true;
            $.arePermissionDenied = false;
            $.isCameraPermissionGranted = true;
            $.isAudioPermissionGranted = true;
            $.previewStream.play("video-preview");
            $.handleDeviceSwitch();
            if (document.getElementById("video1000000001")) {
              document.getElementById("video1000000001").style.left = "0";
            }
            setInterval(() => {
              $.audioLevel = $.previewStream.getAudioLevel();
              // console.log("Audio level: ", $.previewStream.getAudioLevel());
              if ($.audioLevel > 0) {
                if (document.getElementById(`left-audio-indicator`)) {
                  let leftAudioIndicator = document.getElementById(
                    `left-audio-indicator`
                  );
                  leftAudioIndicator.style.height = `${$.audioLevel + 0.375}em`;
                  // console.log(`left: ${leftAudioIndicator.style.height}`);
                }
                if (document.getElementById(`right-audio-indicator`)) {
                  let rightAudioIndicator = document.getElementById(
                    `right-audio-indicator`
                  );
                  rightAudioIndicator.style.height = `${$.audioLevel +
                    0.675}em`;
                  // console.log(`right: ${rightAudioIndicator.style.height}`);
                }
                if (document.getElementById(`main-audio-indicator`)) {
                  let mainAudioIndicator = document.getElementById(
                    `main-audio-indicator`
                  );
                  mainAudioIndicator.style.height = `${$.audioLevel + 0.375}em`;
                  // console.log(`main: ${mainAudioIndicator.style.height}`);
                }
              } else {
                if (document.getElementById(`left-audio-indicator`)) {
                  let leftAudioIndicator = document.getElementById(
                    `left-audio-indicator`
                  );
                  leftAudioIndicator.style.height = `0.1em`;
                }
                if (document.getElementById(`right-audio-indicator`)) {
                  let rightAudioIndicator = document.getElementById(
                    `right-audio-indicator`
                  );
                  rightAudioIndicator.style.height = `0.1em`;
                }
                if (document.getElementById(`main-audio-indicator`)) {
                  let mainAudioIndicator = document.getElementById(
                    `main-audio-indicator`
                  );
                  mainAudioIndicator.style.height = `0.1em`;
                }
              }
            }, 200);
          },
          () => {
            $.arePermissionGranted = false;
            $.arePermissionDenied = true;
          }
        );
      });
    },
    submitSetting() {
      const $ = this;

      let data = {
        selectedMic: $.selectedMic,
        selectedCamera: $.selectedCamera,
      };
      const req = [
        {
          type: "",
          deviceId: "",
        },
        {
          type: "",
          deviceId: "",
        },
      ];
      $.audioDeviceConfiguration.forEach((item) => {
        if (item.label === data.selectedMic) {
          req[0].type = "audio";
          req[0].deviceId = item.deviceId;
          $.$store.state.microphoneId = item.deviceId;
        }
      });
      $.videoDeviceConfiguration.forEach((item) => {
        if (item.label === data.selectedCamera) {
          req[1].type = "video";
          req[1].deviceId = item.deviceId;
          $.$store.state.cameraId = item.deviceId;
        }
      });
      $.previewStream && $.previewStream.close();
      document.getElementById(`player_${$.uid}`).remove();
    },
    handleDeviceSwitch() {
      // Get all audio and video devices
      const $ = this;
      $.preferencesSaved = true;
      AgoraRTC.getDevices(function(devices) {
        const audioDevices = devices.filter(function(device) {
          return device.kind === "audioinput";
        });
        $.audioDeviceConfiguration = audioDevices;
        if (audioDevices.length > 0) {
          audioDevices.forEach((item) => {
            if (!$.audioDeviceContainer.includes(item.label)) {
              $.audioDeviceContainer.push(item.label);
            }
          });
          $.selectedMic = $.audioDeviceContainer[0];
        }
        const videoDevices = devices.filter(function(device) {
          return device.kind === "videoinput";
        });
        $.videoDeviceConfiguration = videoDevices;
        if (videoDevices.length > 0) {
          videoDevices.forEach((item) => {
            if (!$.videoDeviceContainer.includes(item.label)) {
              $.videoDeviceContainer.push(item.label);
            }
          });
          $.selectedCamera = $.videoDeviceContainer[0];
        }
      });
    },
    submit() {
      const $ = this;

      let data = {
        selectedMic: $.selectedMic,
        selectedCamera: $.selectedCamera,
      };
      const req = [
        {
          type: "",
          deviceId: "",
        },
        {
          type: "",
          deviceId: "",
        },
      ];
      $.audioDeviceConfiguration.forEach((item) => {
        if (item.label === data.selectedMic) {
          req[0].type = "audio";
          req[0].deviceId = item.deviceId;
          $.$store.state.microphoneId = item.deviceId;
        }
      });
      $.videoDeviceConfiguration.forEach((item) => {
        if (item.label === data.selectedCamera) {
          req[1].type = "video";
          req[1].deviceId = item.deviceId;
          $.$store.state.cameraId = item.deviceId;
        }
      });
      $.previewStream.close();
      this.$store.state.showPermission = false;
      // this.$router.push({
      //   name: "agoraVideoCall",
      //   params: { id: this.$route.params.id, name: this.$route.params.name },
      // });
    },
    handleMic(e) {
      e.currentTarget.classList.toggle("off");
      if (this.previewStream.isAudioOn()) {
        this.$toast.open({
          message: "Mute",
          type: "info",
          position: "bottom",
          queue: true,
        });
        this.previewStream.disableAudio();
      } else {
        this.$toast.open({
          message: "Unmute",
          type: "success",
          position: "bottom",
          queue: true,
        });
        this.previewStream.enableAudio();
      }
    },
    handleCamera(e) {
      e.currentTarget.classList.toggle("off");
      if (this.previewStream.isVideoOn()) {
        this.$toast.open({
          message: "Video is disable",
          type: "info",
          position: "bottom",
          queue: true,
        });
        this.previewStream.muteVideo();
        let user_info = JSON.parse(localStorage.getItem("user_info"));
        let targetElement = document.getElementById(`player_${user_info.uid}`);
        var img = document.createElement("img");
        img.src = `${user_info.photoURL}`;
        img.style.position = "absolute";
        img.setAttribute("id", "user_photo_client");
        img.style.top = "50%";
        img.style.left = "50%";
        img.style.transform = "translate(-50%, -50%)";
        targetElement.appendChild(img);
      } else {
        this.$toast.open({
          message: "Video is enable",
          type: "success",
          position: "bottom",
          queue: true,
        });
        let userPhoto = document.getElementById(`user_photo_client`);
        userPhoto.remove();
        this.previewStream.unmuteVideo();
        // jquery(`#video${this.user.uid}`).show();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.settings-text h3,
.settings-text button {
  margin-top: 55px;
  margin-left: 55px;
}
.settings-text button {
  margin-top: 25px;
}
.permission-not-granted {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  align-items: center;
  z-index: 99;
}
.default {
  display: none;
}
.permission-not-granted > * {
  margin: 15px;
}
.audio-indicator {
  border-radius: 5px;
  max-height: 1rem;
  height: 0.15rem;
  width: 4px;
  background-color: #ffb229;
  transition: 0.3s ease all;
  margin-left: 2px;
}
#setting-info {
  position: relative;
  margin-top: 5px;
  cursor: pointer;
}

#setting-info .tooltip-text {
  visibility: hidden;
  width: 370px;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
  position: absolute;
  left: -10px;
  top: -130px;
  z-index: 1;
}
.tooltip-text {
  margin-top: -55px;
}
#setting-info:hover .tooltip-text {
  visibility: visible;
}
</style>
